import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Location } from 'history';
import { Redirect, Route, Switch } from 'react-router-dom';

import { View } from 'src/components/common';

import { IRootState } from 'src/redux/rootReducer';

import './styles.scss';
import { PATHS } from 'src/appConfig/paths';
import Timesheet from './Timesheet';
import commonActions from 'src/redux/commonRedux/actions';
import { useComponentDidMount, useComponentWillUnmount } from 'src/hooks';
import EmployeesContainer from '../EmployeesContainer';
import LayoutWithSidebar from 'src/layout/LayoutWithSidebar';
import Sidebar from 'src/components/Sidebar';
import JobCodesContainer from '../TablesContainer/JobCodesContainer';
import TasksContainer from '../TablesContainer/TasksContainer';
import PhaseCodesContainer from '../TablesContainer/PhaseCodesContainer';
import UsersContainer from '../UsersContainer';
import { setActiveTimesheetTab, setDateRange } from 'src/redux/timesheet/actions';
import { TabIdx } from 'src/containers/HomeContainers/Timesheet/tableHelpers';
import { getInitialDateRange } from 'src/utils/momentUtils';

const Home: React.FC<Props> = ({
  user,
  onSetActiveTimesheet,
  location,
  onSetCollapseSidebar,
  onSetSecondBurger,
  onSetSidebar,
  onSetDateRange,
}) => {
  useEffect(() => {
    if (
      [PATHS.homeJobCodes, PATHS.homePhaseCodes, PATHS.homeUser, PATHS.homeTasks, PATHS.homeEmployee].includes(
        window.location.pathname,
      )
    ) {
      const isAdmin = user?.role === 'ADMIN';
      onSetActiveTimesheet(isAdmin ? TabIdx.All : TabIdx.Week);
      onSetDateRange(getInitialDateRange(isAdmin));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.pathname]);
  useComponentDidMount(() => {
    onSetSecondBurger(true);
    onSetSidebar(true);
  });
  useComponentWillUnmount(() => {
    onSetSecondBurger(false);
    onSetSidebar(false);
  });

  const renderBody = () => {
    return (
      <Switch location={location}>
        <Route path={PATHS.homeTimesheet} component={Timesheet} />
        <Route path={PATHS.homeEmployee} component={EmployeesContainer} />
        <Route path={PATHS.homeUser} component={UsersContainer} />
        <Route path={PATHS.homeJobCodes} component={JobCodesContainer} />
        <Route path={PATHS.homeTasks} component={TasksContainer} />
        <Route path={PATHS.homePhaseCodes} component={PhaseCodesContainer} />
        <Route render={() => <Redirect to={PATHS.homeTimesheet} />} />
      </Switch>
    );
  };

  return (
    <View className="container ctn-home is-wider-screen">
      <LayoutWithSidebar
        sidebar={
          <View className="mt-32">
            <Sidebar />
          </View>
        }
        body={renderBody()}
        footer={null}
      />
    </View>
  );
};

type Props = ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps & { location: Location };

const mapStateToProps = (state: IRootState) => ({
  user: state.auth.authUser,
});

const mapDispatchToProps = {
  onSetSecondBurger: commonActions.setShowSecondBurger,
  onSetCollapseSidebar: commonActions.setCollapseSidebar,
  onSetSidebar: commonActions.setSidebar,
  onSetActiveTimesheet: setActiveTimesheetTab,
  onSetDateRange: setDateRange,
};
export default connect(mapStateToProps, mapDispatchToProps)(Home);
